import { takeEvery, call, put, all } from 'redux-saga/effects';

import * as types from './projectActionTypes';
import * as actions from './projectActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';

const getProjectIdFromResponse = (responseData) => {
  return responseData?.result?.id || responseData?.id || null;
};

const createProjectMediaFormData = (media) => {
  if (!media?.image && !media?.logo) {
    return null;
  }

  const formData = new FormData();

  if (media?.image) {
    formData.append('image', media.image);
  }

  if (media?.logo) {
    formData.append('logo', media.logo);
  }

  return formData;
};
//Worker Sagas

function* getProjectsSaga(action) {
  try {
    const filter = action?.payload?.filter;
    const { data } = yield call(endpoints.getProjects, filter);
    yield put(actions.getProjectsActionData(data));
    yield put(actions.sortProjectsAction());
  } catch (e) {
    yield put(actions.getProjectsActionError(e));
    errorHandler(e)
  }
}

function* createProjectSaga(action) {
  try {
    const { body, media } = action.payload;
    console.log(body);
    const { data } = yield call(endpoints.createProject, body);

    try {
      const projectID = getProjectIdFromResponse(data);
      const mediaFormData = createProjectMediaFormData(media);

      if (projectID && mediaFormData) {
        yield call(endpoints.putProjectImageLogo, projectID, mediaFormData);
      }
    } catch (mediaUploadError) {
      yield put(
        alert.setAlertAction({
          title: 'Warning!',
          text: 'Project is created but image/logo upload failed.',
          variant: 'warning',
          outTimeMS: 6000,
        }),
      );
      errorHandler(mediaUploadError);
    }

    yield put(actions.createProjectActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: "Project creation process is successful.",
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e) 
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.createProjectActionError(e));
  }
}

function* updateProjectSaga(action) {
  try {
    const { projectID, body, media } = action.payload;
    console.log(projectID);
    console.log(body);
    const { data } = yield call(endpoints.updateProject, projectID, body);

    try {
      const mediaFormData = createProjectMediaFormData(media);

      if (projectID && mediaFormData) {
        yield call(endpoints.putProjectImageLogo, projectID, mediaFormData);
      }
    } catch (mediaUploadError) {
      yield put(
        alert.setAlertAction({
          title: 'Warning!',
          text: 'Project is updated but image/logo upload failed.',
          variant: 'warning',
          outTimeMS: 6000,
        }),
      );
      errorHandler(mediaUploadError);
    }

    console.log(data);
    yield put(actions.updateProjectActionData(data));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: "The project update process is successful.",
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e) 
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.updateProjectActionError(e));
  }
}

function* deleteProjectSaga(action) {
  try {
    const { projectID } = action.payload;
    console.log('deleteProjectSaga: ', projectID);
    const { data } = yield call(endpoints.deleteProject, projectID);
    yield put(actions.deleteProjectActionData(projectID));
    yield put(
      alert.setAlertAction({
        title: 'Success!',
        text: "The project deletion process is successful.",
        variant: 'success',
      }),
    );
  } catch (e) {
    errorHandler(e) 
    yield put(
      alert.setAlertAction({
        title: 'Error!',
        text: e?.response?.data?.detail,
        variant: 'danger',
        outTimeMS: 6000,
      }),
    );
    yield put(actions.deleteProjectActionError(e));
  }
}

//Watcher Sagas
function* watchGetProjects() {
  yield takeEvery(types.GET_PROJECTS_REQUEST, getProjectsSaga);
}
function* watchCreateProject() {
  yield takeEvery(types.CREATE_PROJECT_REQUEST, createProjectSaga);
}

function* watchUpdateProject() {
  yield takeEvery(types.UPDATE_PROJECT_REQUEST, updateProjectSaga);
}

function* watchDeleteProject() {
  yield takeEvery(types.DELETE_PROJECT_REQUEST, deleteProjectSaga);
}

export function* projectSaga() {
  yield all([watchGetProjects(), watchDeleteProject(), watchCreateProject(), watchUpdateProject()]);
}
